import { GET_TIMEZONES_FAILURE, GET_TIMEZONES_REQUEST, GET_TIMEZONES_SUCCESS } from '../actions/timezones'

const initialState = {
	data: null,
	isFetching: false,
	isError: false
}

export default function timezones(state = initialState, action = {}) {
	switch (action.type) {
		case GET_TIMEZONES_REQUEST:
			return Object.assign({}, state, {
				data: null,
				isFetching: true,
				isError: false
			})

		case GET_TIMEZONES_SUCCESS: {
			return Object.assign({}, state, {
				data: action.data,
				isFetching: false,
				isError: false
			})
		}

		case GET_TIMEZONES_FAILURE:
			return Object.assign({}, state, {
				data: null,
				isFetching: false,
				isError: true
			})

		default:
			return state
	}
}
